(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ko-amazon-review-link-inline"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-ko-amazon-inline]').forEach((container) => {
        if (container.dataset.koAmazonInitialized === 'true') return;

        const mapNode = container.querySelector('[data-ko-amazon-variant-map]');
        const link = container.querySelector('[data-ko-amazon-url]');
        if (!mapNode || !link) return;

        let variantLinks = {};
        try {
          variantLinks = JSON.parse(mapNode.textContent);
        } catch (error) {
          return;
        }

        const update = (variantId) => {
          const url = variantLinks[String(variantId)] || '';
          container.hidden = url === '';

          if (url === '') {
            link.removeAttribute('href');
          } else {
            link.href = url;
          }
        };

        container.dataset.koAmazonInitialized = 'true';
        update(container.dataset.currentVariantId);

        document.addEventListener('variant:change', (event) => {
          const variantId = event.detail?.variant?.id || event.detail?.variantId;
          if (variantId) update(variantId);
        });

        document.addEventListener('change', () => {
          window.setTimeout(() => {
            const urlVariant = new URL(window.location.href).searchParams.get('variant');
            if (urlVariant) update(urlVariant);
          }, 0);
        });

        window.addEventListener('popstate', () => {
          const urlVariant = new URL(window.location.href).searchParams.get('variant');
          if (urlVariant) update(urlVariant);
        });
      });
    };

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
